import { render } from "./AddressBookView.vue?vue&type=template&id=49c3ddd8&scoped=true"
import script from "./AddressBookView.vue?vue&type=script&lang=js"
export * from "./AddressBookView.vue?vue&type=script&lang=js"

import "./AddressBookView.vue?vue&type=style&index=0&id=49c3ddd8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49c3ddd8"]])

export default __exports__